import * as angular from 'angular';
import template from './raspberryPiConfig.tpl.html';

export default angular.module('aps.controller.raspberryPiConfig', [])
  .directive('apsRaspberryPiConfig', (): angular.IDirective => {
    return {
      restrict: 'E',
      template: template
    };
  })
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/app/controllers/equipment/raspberryPiConfig.directive.ts